/**
 * analytics.js
 *
 * Minimal Google Analytics 4 wrapper. No-ops entirely if
 * REACT_APP_GA_MEASUREMENT_ID isn't set (e.g. local dev) — no script loads,
 * no calls fire. Pageviews are tracked manually on route change since this
 * is a client-routed SPA (gtag's automatic pageview only fires once, on
 * initial script load).
 */

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || null;
let initialized = false;

export function initAnalytics() {
  if (!GA_ID || initialized || typeof window === 'undefined') return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (!GA_ID || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}
